var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vg-scan-qr-code"},[_c('vg-scan-qr-code',{ref:"scan",staticClass:"vg-scan-qr-code-camara",attrs:{"aspect-ratio":_vm.aspectRatio},on:{"success-text":_vm.onSuccess,"error-message":_vm.onError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }